/**
 * djb2 string hash — collapses arbitrary text into a short, stable comparison key.
 *
 * Used for cache/generation keys where the whole input matters but the key has to stay
 * short. Not cryptographic; do not use it for anything security-bearing.
 */
export const djb2 = (str) => {
  const input = str || "";
  let hash = 5381;
  for (let i = 0; i < input.length; i += 1) {
    hash = ((hash << 5) + hash + input.charCodeAt(i)) | 0;
  }
  return (hash >>> 0).toString(36);
};

export default djb2;
